import React from "react";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

const ACTIVE_BG = "#EC7F54";

interface FilterOption {
  key: string;
  label: string;
}

interface TrebbleFilterButtonsProps {
  filters: FilterOption[];
  activeFilter: string;
  onFilterChange: (key: string) => void;
  useEditorTheme?: boolean;
}

const TrebbleFilterButtons: React.FC<TrebbleFilterButtonsProps> = ({
  filters,
  activeFilter,
  onFilterChange,
  useEditorTheme,
}) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {filters.map((filter) => {
          const isActive = filter.key === activeFilter;
          return (
            <button
              key={filter.key}
              type="button"
              onClick={() => onFilterChange(filter.key)}
              className={isActive ? "library-filter-btn library-filter-btn--active" : "library-filter-btn"}
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "6px 18px",
                fontSize: "var(--text-base)",
                fontWeight: isActive ? 700 : 400,
                lineHeight: "22px",
                border: isActive
                  ? `1px solid ${ACTIVE_BG}`
                  : "1px solid var(--border-default-color, #ddd)",
                backgroundColor: isActive
                  ? ACTIVE_BG
                  : "var(--bg-default, #fff)",
                color: isActive
                  ? "#fff"
                  : "var(--text-default-color, #555)",
                cursor: "pointer",
                transition: "all 0.15s ease",
                fontFamily: "inherit",
              }}
            >
              {filter.label}
            </button>
          );
        })}
      </div>
    </TrebbleConfigProvider>
  );
};

export default TrebbleFilterButtons;
